export default __webpack_public_path__ + "static/media/spotlight_mandy_luk_664x830_fr.cae894b2.jpg";